export default __webpack_public_path__ + "static/media/ipams.b9596847.jpg";